import { createContext } from 'react';

const DataFlowContext = createContext({});

export default DataFlowContext;
